// FatSpline.tsx
import React, { useRef, useMemo } from 'react';
import { useFrame, extend } from '@react-three/fiber';
import * as THREE from 'three';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';

extend({ Line2, LineMaterial, LineGeometry });

const FatSpline: React.FC = () => {
    const ref = useRef<any>();
    const points = useMemo(() => Array.from({ length: 3 }, () =>
        new THREE.Vector3((Math.random() - 0.5) * 10, (Math.random() - 0.5) * 10, 0)
    ), []);

    useFrame(({ clock, size }) => {
        const t = clock.getElapsedTime();
        points.forEach((p, i) => (p.y = Math.sin(t + i) * 2));
        if (ref.current) {
            const curve = new THREE.CatmullRomCurve3(points, true);
            const positions = curve.getPoints(100).flatMap(p => [p.x, p.y, p.z]);
            ref.current.geometry.setPositions(positions);
            ref.current.material.resolution.set(size.width, size.height);
        }
    });

    return (
        <line2 ref={ref}>
            <lineGeometry attach="geometry" positions={points.flatMap(p => [p.x, p.y, p.z])} />
            <lineMaterial attach="material" color={0xff00ff} linewidth={1} />
        </line2>
    );
};

export default FatSpline;